import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}/gescon`

export default {
    obterContratos() {
        return axiosJwt
            .get(`${api}/fornecedor/contratos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/pagamentos?contrato=${filtro.contrato}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentosDisponiveis(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoId}/comprometimentosdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarComprometimentos(pagamentoComprometimentos) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoComprometimentos.pagamentoId}/associarcomprometimentos`,
                pagamentoComprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarComprometimento(pagamentoComprometimento) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoComprometimento.pagamentoId}/desassociarcomprometimento`,
                pagamentoComprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamento(novoPagamento) {
        return axiosJwt
            .post(`${api}/fornecedor/contratos/pagamentos`, novoPagamento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    validarInserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroDocumento', pagamentoAnexo.numeroDocumento)
        if (pagamentoAnexo.dataEmissao != null) {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }

        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoAnexo.pagamentoId}/anexos/validar`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroDocumento', pagamentoAnexo.numeroDocumento)
        if (pagamentoAnexo.dataEmissao != null) {
            formData.append('dataEmissao', pagamentoAnexo.dataEmissao)
        }
        if (pagamentoAnexo.justificativa != null) {
            formData.append('justificativaAnexoDuplicado', pagamentoAnexo.justificativa)
        }

        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarPagamentoParaAnalise(pagamentoDto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoDto.pagamentoId}/analisar`,
                pagamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/pagamentos/anexos/${pagamentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(idComprometimento) {
        let url = `${api}/fornecedor/contratos/pagamentos/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(idComprometimento) {
        let url = `${api}/fornecedor/contratos/pagamentos/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(idComprometimento, comprometimentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/pagamentos/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarAutorizcao(solicitacaoDto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${solicitacaoDto.pagamentoId}/solicitarautorizacao`,
                solicitacaoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        let url = `${api}/fornecedor/contratos/pagamentos/${pagamentoId}/timeline`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLineComprometimento(comprometimentoId) {
        let url = `${api}/fornecedor/contratos/pagamentos/comprometimentos/${comprometimentoId}/timeline`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    
    obterNotasFiscais(pagamentoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/pagamentos/${pagamentoId}/notasfiscais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoNotaFiscal(pagamentoNotaFiscal) {
    
        let dataEmissao = pagamentoNotaFiscal.dataEmissao
        if (typeof dataEmissao === 'string' && dataEmissao.includes('/')) {
            const parts = dataEmissao.split('/')
            if (parts.length === 3) {
                dataEmissao = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`
            }
        }

        const notaFiscalDto = {
            pagamentoId: pagamentoNotaFiscal.pagamentoId,
            tipo: pagamentoNotaFiscal.tipo,
            numeroNota: pagamentoNotaFiscal.numeroNota,
            dataEmissao: dataEmissao,
            mesCompetencia: pagamentoNotaFiscal.mesCompetencia,
            valorNota: pagamentoNotaFiscal.valorNota,
            localPrestacao: pagamentoNotaFiscal.localPrestacao,
            servicoPorSocio: pagamentoNotaFiscal.servicoPorSocio,

           
            prestadorCnpjCpf: pagamentoNotaFiscal.prestadorCnpjCpf,
            prestadorInscricaoMunicipal: pagamentoNotaFiscal.prestadorInscricaoMunicipal,
            prestadorRazaoSocial: pagamentoNotaFiscal.prestadorRazaoSocial,
            prestadorNomeFantasia: pagamentoNotaFiscal.prestadorNomeFantasia,
            prestadorOptanteSimples: pagamentoNotaFiscal.prestadorOptanteSimples,
            prestadorTelefone: pagamentoNotaFiscal.prestadorTelefone,
            prestadorEmail: pagamentoNotaFiscal.prestadorEmail,
            prestadorEndereco: pagamentoNotaFiscal.prestadorEndereco,

          
            tomadorCnpjCpf: pagamentoNotaFiscal.tomadorCnpjCpf,
            tomadorRazaoSocial: pagamentoNotaFiscal.tomadorRazaoSocial,
            tomadorEmail: pagamentoNotaFiscal.tomadorEmail,
            tomadorTelefone: pagamentoNotaFiscal.tomadorTelefone,
            tomadorEndereco: pagamentoNotaFiscal.tomadorEndereco,

           
            valorServico: pagamentoNotaFiscal.valorServico,
            valorDeducao: pagamentoNotaFiscal.valorDeducao,
            deducaoIss: pagamentoNotaFiscal.deducaoIss,
            deducaoInss: pagamentoNotaFiscal.deducaoInss,
            valorIss: pagamentoNotaFiscal.valorIss,
            valorPis: pagamentoNotaFiscal.valorPis,
            valorCofins: pagamentoNotaFiscal.valorCofins,
            valorInss: pagamentoNotaFiscal.valorInss,
            valorIr: pagamentoNotaFiscal.valorIr,
            valorCsll: pagamentoNotaFiscal.valorCsll,
            valorIbs: pagamentoNotaFiscal.valorIbs,
            valorCbs: pagamentoNotaFiscal.valorCbs,

           
            aliquotaIss: pagamentoNotaFiscal.aliquotaIss,
            aliquotaPis: pagamentoNotaFiscal.aliquotaPis,
            aliquotaCofins: pagamentoNotaFiscal.aliquotaCofins,
            aliquotaInss: pagamentoNotaFiscal.aliquotaInss,
            aliquotaIr: pagamentoNotaFiscal.aliquotaIr,
            aliquotaCsll: pagamentoNotaFiscal.aliquotaCsll,
            aliquotaIbs: pagamentoNotaFiscal.aliquotaIbs,
            aliquotaCbs: pagamentoNotaFiscal.aliquotaCbs,

          
            codigoAtividade: pagamentoNotaFiscal.codigoAtividade,
            descricaoAtividade: pagamentoNotaFiscal.descricaoAtividade,
            cosServico: pagamentoNotaFiscal.cosServico,
            descricaoServico: pagamentoNotaFiscal.descricaoServico,
            descricaoNota: pagamentoNotaFiscal.descricaoNota
        }

         const formData = new FormData()
        formData.append('notaFiscal', JSON.stringify(notaFiscalDto))
        if (pagamentoNotaFiscal.arquivo) {
            formData.append('arquivo', pagamentoNotaFiscal.arquivo)
        }

        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoNotaFiscal.pagamentoId}/notasfiscais`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirNotaFiscal(pagamentoId, notaFiscalId) {
        return axiosJwt
            .delete(`${api}/fornecedor/contratos/pagamentos/${pagamentoId}/notasfiscais/${notaFiscalId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadNotaFiscal(pagamentoNotaFiscalId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/pagamentos/notasfiscais/${pagamentoNotaFiscalId}/download`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterMunicipios(uf = 'PE') {
        return axiosJwt
            .get(`${api}/v1/pagamentos/municipios/${uf}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
